export const DATADOG_SITE = 'datadoghq.com';
